// import config
import axios from '../config/axios';

export const templateList = async (reqData) => {
    try {
        const respData = await axios({
            'url': `/api/admin/emailTemplate`,
            'method': 'get',
            'params': reqData
        })
        return {
            status: "success",
            loading: false,
            result: respData.data.result
        }
    } catch (err) {
        return {
            status: 'failed',
            loading: false
        }
    }
}

export const editEmailTemplate = async (data) => {
    try {
        const respData = await axios({
            'url': `/api/admin/emailTemplate`,
            'method': 'put',
            'data': data
        })
        return {
            status: "success",
            loading: false,
            message: respData.data.message
        }
    } catch (err) {
        return {
            status: 'failed',
            loading: false,
            message: err.response.data.message,
            error: err.response.data.errors
        }
    }
}

export const addEmailTemplate = async (data) => {
    try {
        const respData = await axios({
            'url': `/api/admin/emailTemplate`,
            'method': 'post',
            'data': data
        })
        return {
            status: "success",
            loading: false,
            message: respData.data.message
        }
    } catch (err) {
        return {
            status: 'failed',
            loading: false,
            message: err.response.data.message,
            error: err.response.data.errors
        }
    }
}